import { MouseEvent } from 'react';

const stopEventPropagation = (event: MouseEvent<HTMLDivElement | HTMLButtonElement | HTMLLIElement>) => {
  // Preventing any parent handlers from being notified of the event
  event.stopPropagation();
};

export default stopEventPropagation;
